import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/app-insights';

export const PageViewTracker = (): null => {
	const location = useLocation();

	useEffect(() => {
		// Custom properties (OrganisationId, UserId) are automatically added
		// by the telemetry initializer in app-insights.ts
		trackPageView(location.pathname);
	}, [location.pathname]);

	return null;
};
